import { Button, TextField, Toolbar, Typography } from '@mui/material';
import AddUpdateMeetingDialog from 'app/components/Dialog/AddUpdateMeetingDialog';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentMeeting } from 'stores/meeting';


function MeetingDataTableToolbar({ pageTitle, afterUpdateFunc, addAfterTable, isManagementPage, setHighlightQuery, onSearchSubmit }) {

  const [addMeetingDialogStatus, setAddMeetingDialogStatus] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const dispatch = useDispatch();

  const handleSearchSubmit = () => {
    onSearchSubmit(searchInput);
    setHighlightQuery(searchInput);
  };


  const handleAddButtonClick = async () => {
    dispatch(setCurrentMeeting({}))
    setAddMeetingDialogStatus(true)
  }



  return (
    <Toolbar className="table-header row" sx={{ justifyContent: 'space-between' }}>
      <div className="title">
        <Typography variant="title">{pageTitle}</Typography>
      </div>

      <div>

        {
          isManagementPage && <Button variant="contained" sx={{ marginTop: '14px', marginRight: '10px' }} size="medium" onClick={
            () => handleAddButtonClick()
          }>Toplantı Ekle</Button>

        }

        <TextField
          id="searchText1xe"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearchSubmit();
            }
          }}
          margin="dense"
          label={"Arama Yap"}
          className="mr-4"
          style={{ width: "400px", background: 'white' }}
          placeholder={"Aradıktan sonra Enter'a basın"}
        />
      </div>
      <AddUpdateMeetingDialog open={addMeetingDialogStatus} onClose={() => setAddMeetingDialogStatus(false)} afterUpdateFunc={afterUpdateFunc} addAfterTable={addAfterTable} />
    </Toolbar>
  );
}

export default MeetingDataTableToolbar
